import { LinkProps, Link as MuiLink } from "@mui/material";

type Props = LinkProps;

export const Link = ({ ...props }: Props) => {
  return <MuiLink {...props} />;
};

export function AnyComponentLink<C extends React.ElementType>(props: LinkProps<C, { component?: C }>) {
  return <Link {...props} />;
}

export type { LinkProps };
